import { Trash2 } from 'lucide-react';

function ClearFieldButton({ visible, onClick }) {
  if (!visible) return null;
  return (
    <button type="button" onClick={onClick} tabIndex={-1}
      className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 text-zinc-600 transition-colors hover:text-red-400"
      aria-label="Effacer">
      <Trash2 className="h-3 w-3" />
    </button>
  );
}

function RecursiveToggle({ isRecursive, setIsRecursive, crawling }) {
  return (
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        id="isRecursive"
        data-testid="recursive-crawl-checkbox"
        checked={isRecursive}
        onChange={(event) => setIsRecursive(event.target.checked)}
        disabled={crawling}
        className="h-4 w-4 rounded border-zinc-800 bg-zinc-900 accent-white"
      />
      <label htmlFor="isRecursive" className="text-sm font-medium">
        Crawl récursif (tout le site)
      </label>
    </div>
  );
}

function MaxPagesField({ maxPages, setMaxPages, crawling }) {
  return (
    <div className="flex items-center gap-3">
      <label htmlFor="maxPages" className="text-xs">Max pages :</label>
      <input
        type="number"
        id="maxPages"
        data-testid="recursive-max-pages-input"
        value={maxPages}
        onChange={(event) => setMaxPages(parseInt(event.target.value, 10) || 50)}
        min="1"
        disabled={crawling}
        className="h-8 w-20 rounded-sm border border-zinc-800 bg-zinc-900 px-2 text-sm text-white focus:border-white focus:outline-none focus:ring-0"
      />
    </div>
  );
}

function UrlPrefixField({ urlPrefix, setUrlPrefix, crawling }) {
  return (
    <div className="space-y-1">
      <label htmlFor="urlPrefix" className="text-xs text-zinc-400">Préfixe URL (optionnel) :</label>
      <div className="relative">
        <input
          type="url"
          id="urlPrefix"
          data-testid="url-prefix-input"
          value={urlPrefix}
          onChange={(event) => setUrlPrefix(event.target.value)}
          placeholder="https://exemple.com/docs/"
          disabled={crawling}
          className="h-8 w-full rounded-sm border border-zinc-800 bg-zinc-900 px-3 pr-7 text-xs text-white placeholder:text-zinc-600 focus:border-white focus:outline-none focus:ring-0"
        />
        <ClearFieldButton visible={urlPrefix.length > 0} onClick={() => setUrlPrefix('')} />
      </div>
      <p className="text-xs text-zinc-500">Seules les URLs commençant par ce préfixe seront crawlées.</p>
    </div>
  );
}

function RecursiveFields({ maxPages, setMaxPages, urlPrefix, setUrlPrefix, crawling }) {
  return (
    <div className="ml-6 space-y-3">
      <p className="text-xs text-zinc-400">
        Suit automatiquement les liens du site, reste sur le même domaine, ignore les doublons et exclut les pages non utiles.
      </p>
      <MaxPagesField maxPages={maxPages} setMaxPages={setMaxPages} crawling={crawling} />
      <UrlPrefixField urlPrefix={urlPrefix} setUrlPrefix={setUrlPrefix} crawling={crawling} />
    </div>
  );
}

export function CrawlRecursiveOptions({ isRecursive, setIsRecursive, maxPages, setMaxPages, urlPrefix, setUrlPrefix, crawling }) {
  return (
    <div className="space-y-3 rounded-sm border border-zinc-800 bg-zinc-900/30 p-4">
      <RecursiveToggle isRecursive={isRecursive} setIsRecursive={setIsRecursive} crawling={crawling} />
      {isRecursive ? (
        <RecursiveFields
          maxPages={maxPages} setMaxPages={setMaxPages}
          urlPrefix={urlPrefix} setUrlPrefix={setUrlPrefix}
          crawling={crawling}
        />
      ) : null}
    </div>
  );
}
